import React from 'react';
import {
    COVER_DIM_ON_LIGHT,
    COVER_DISPLAY_FONT_VAR,
    CoverLogo,
    CoverMetaSmall,
    coverTitleSize,
    type CoverTemplateProps,
} from './shared';

/** Arcos concêntricos em tons dessaturados da cor primária sobem da base. */
export const Arco: React.FC<CoverTemplateProps> = ({ fields, colors, logoUrl, showLogo }) => (
    <div className="relative flex size-full flex-col overflow-hidden px-[2.8em] pt-[3em]">
        <div
            className="absolute bottom-0 left-1/2 h-[34em] w-[150%] -translate-x-1/2"
            style={{
                borderRadius: '50% 50% 0 0 / 100% 100% 0 0',
                backgroundColor: `color-mix(in srgb, ${colors.primary} 9%, white)`,
            }}
        />
        <div
            className="absolute bottom-0 left-1/2 h-[26.5em] w-[118%] -translate-x-1/2"
            style={{
                borderRadius: '50% 50% 0 0 / 100% 100% 0 0',
                backgroundColor: `color-mix(in srgb, ${colors.primary} 17%, white)`,
            }}
        />
        <div className="relative flex justify-end">
            <CoverLogo logoUrl={logoUrl} showLogo={showLogo} className="h-[2.4em]" />
        </div>
        <div className="relative mt-[5.4em]">
            <div
                className="font-bold leading-[1.05] tracking-[-0.015em]"
                style={{
                    fontFamily: COVER_DISPLAY_FONT_VAR,
                    fontSize: coverTitleSize(2.55),
                }}
            >
                {fields.document_title}
            </div>
            {fields.subtitle ? (
                <div
                    className="mt-[1.3em] uppercase tracking-[0.3em]"
                    style={{
                        fontSize: coverTitleSize(0.62),
                        color: COVER_DIM_ON_LIGHT,
                    }}
                >
                    {fields.subtitle}
                </div>
            ) : null}
        </div>
        <CoverMetaSmall
            fields={fields}
            dimColor="#3d4657"
            className="relative mt-auto pb-[3em] text-center"
        />
    </div>
);
